import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { DailyProduction } from './daily-production/daily-production';
import { TotalProduction } from './total-production/total-production';
import { Co2Savings } from './co2-savings/co2-savings';
import { TotalSystems } from './total-systems/total-systems';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-overview-table',
  imports: [MatButtonModule, MatCardModule, MatMenuModule, DailyProduction, TotalProduction, Co2Savings, TotalSystems, TranslatePipe],
  templateUrl: './overview-table.html',
  styleUrl: './overview-table.scss'
})
export class OverviewTable {}